import React from 'react';
import {
  NEW_WORK_COLOR,
  REFACTOR_COLOR,
  REWORK_COLOR
} from 'common/constants/_colors';
import { calculatePercentage } from 'common/utils/utils';
import LinearProgressFiller from '../LinearProgressFiller';

const WorkBeakdownProgress = ({ newWork, rework, refactor, changes }) => {
  const newWorkPercent = calculatePercentage(newWork, changes);
  const refactorPercent = calculatePercentage(refactor, changes);
  const reworkPercent = calculatePercentage(rework, changes);

  return (
    <LinearProgressFiller
      isRound={false}
      parts={[
        {
          color: NEW_WORK_COLOR,
          percent: newWorkPercent
        },
        {
          color: REFACTOR_COLOR,
          percent: refactorPercent
        },
        {
          color: REWORK_COLOR,
          percent: reworkPercent
        }
      ]}
    />
  );
};

export default WorkBeakdownProgress;
